module.exports = __webpack_public_path__ + "static/media/Directory_IGKV_2023.1ad09c2a.pdf";